<ng-container *transloco="let t;">

  <p><strong>{{ t('observer_list.observer_appointments') }}:</strong></p>
  <div class="observer-list">
    <p-table [value]="days" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <ng-container *ngFor="let location of locations">
                  <th class="p-text-center">{{ location.name }}</th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-day>
            <tr>
              <td><p>{{ day.date | amDateFormat: 'DD.MM.YYYY' }}</p></td>
              <ng-container *ngFor="let location of locations">
                <td class="p-text-center">{{ day.locations[location.id].observers }} / {{ day.locations[location.id].observers_gem }}</td>
              </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="locations.length + 1" class="p-text-center">{{ t('observer_list.no_observers_found') }}</td>
            </tr>
        </ng-template>
    </p-table>
  </div>
  <p class="p-mt-2 p-text-small p-text-right">{{ t('observer_list.observer_gem') }}</p>

</ng-container>
